<template>
  <div class="add-project-content">
    <el-breadcrumb class="breadcrumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
      <el-breadcrumb-item>添加项目</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-steps align-center class="step" :space="400" :active="active">
        <el-step class="pointer" title="项目信息" @click.native="handleStep(1)"></el-step>
        <el-step class="pointer" title="项目内容" @click.native="handleStep(2)"></el-step>
        <el-step class="pointer" title="项目规则" @click.native="handleStep(3)"></el-step>
      </el-steps>
    </el-card>

    <div class="content">
      <el-card class="project-info" v-if="active === 1">
        <el-form ref="stepOne" :model="form" :label-width="formLabelWidth" :rules="stepOneFormRules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="名称" prop="name">
                <el-input style="width: 100%;" :size="componentSize" v-model="form.name" placeholder="请输入名称"
                          auto-complete="off" maxlength="20" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="封面" prop="cover">
                <el-upload
                  class="avatar-uploader"
                  :action="fileObj.url"
                  :headers="reqData"
                  list-type="picture"
                  :show-file-list="false"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :before-upload="beforeUpload"
                  :on-success="UploadSuccess">
                  <img v-if="form.cover" :src="form.cover" class="avatar"/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <span style="position: absolute;left: 10px;top: 10px;color: #fff;">{{ form.name }}</span>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="所属科目" prop="subjectId">
                <el-cascader style="width: 100%" clearable v-model="form.courseIds" :show-all-levels="false"
                             :props="subjectTreeProps" placeholder="请选择所属科目" :options="subjectTree"
                             @change="subjectChange"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="项目说明" prop="remark">
                <el-input type="textarea" style="width: 100%;" :size="componentSize" v-model="form.remark"
                          placeholder="请输入备注" auto-complete="off" maxlength="255" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="讲师" prop="remark">
                <el-select placeholder="请选择讲师" style="width:100%" v-model="form.teacherId" clearable filterable>
                  <el-option v-for="item in teacherList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="预算" prop="budget">
                <el-input style="width: 100%;" :size="componentSize" type="number" v-model="form.budget"
                          placeholder="请输入预算" auto-complete="off"
                          onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                          oninput="if(value.length > 8) value=value.slice(0, 8)"
                          clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-row :gutter="20">
          <el-col :span="8" :offset="16">
            <el-button type="primary" @click="saveStepOne">下一步</el-button>
          </el-col>
        </el-row>
      </el-card>

      <el-card class="project-content" v-if="active === 2">
        <div class="title">
          <h1 class="h1">阶段设置</h1>
          <el-divider></el-divider>
        </div>

        <el-tabs v-model="activeTab" type="border-card" @tab-remove="removeTab" @tab-click="clickTab">
          <el-tab-pane :label="'阶段' + item.sn" :name="'阶段' + item.sn"
                       v-for="(item, index) in list" closable :key="index">

            <el-form ref="phaseForm" :model="item" :label-width="formLabelWidth" :rules="phaseFormRules">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="阶段名称" prop="name">
                    <el-input style="width: 100%;" :size="componentSize"
                              v-model="item.name"
                              placeholder="请输入阶段名称"
                              auto-complete="off" maxlength="10" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="阶段说明" prop="remark">
                    <el-input type="textarea" style="width: 100%;" :size="componentSize"
                              v-model="item.remark"
                              placeholder="请输入阶段说明" auto-complete="off" maxlength="255" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="阶段内容" prop="remark">

                    <el-button type="primary" size="mini" @click="showGoodsDialog">
                      <i class="el-icon-video-camera" style="margin-right: 12px;"></i>
                      添加课程
                    </el-button>
                    <el-button type="primary" size="mini" @click="showExamDialog">
                      <i class="el-icon-reading" style="margin-right: 12px;"></i>
                      添加考试
                    </el-button>

                    <div style="width: 100%;margin-top: 24px;">
                      <div style="width: 100%;display: flex;">
                        <div style="width: 20%;border: 1px solid #d9ebf5;background: #fafafa;text-align: center;">序号
                        </div>
                        <div style="width: 20%;border: 1px solid #d9ebf5;background: #fafafa;text-align: center;">类型
                        </div>
                        <div style="width: 20%;border: 1px solid #d9ebf5;background: #fafafa;text-align: center;">名称
                        </div>
                        <div style="width: 20%;border: 1px solid #d9ebf5;background: #fafafa;text-align: center;">内容时长
                        </div>
                        <div style="width: 20%;border: 1px solid #d9ebf5;background: #fafafa;text-align: center;">操作
                        </div>
                      </div>

                      <draggable v-if="item.projectPhaseItemList"
                                 v-model="item.projectPhaseItemList"
                                 @update="handleDrag(e, index)"
                                 :options="{ animation: 500 }">
                        <div style="display: flex;" v-for="(projectPhaseItem, projectPhaseItemIndex) in item.projectPhaseItemList"
                             :key="index" class="drag-item">
                          <div style="width: 20%;border: 1px solid #d9ebf5;text-align: center;">{{ projectPhaseItem.sn }}</div>
                          <div style="width: 20%;border: 1px solid #d9ebf5;text-align: center;">
                            <div v-if="projectPhaseItem.type === 1">课程</div>
                            <div v-if="projectPhaseItem.type === 2">考试</div>
                          </div>
                          <div style="width: 20%;border: 1px solid #d9ebf5;text-align: center;">{{ projectPhaseItem.name }}</div>
                          <div style="width: 20%;border: 1px solid #d9ebf5;text-align: center;">{{ projectPhaseItem.timeLong }}
                          </div>
                          <div style="width: 20%;border: 1px solid #d9ebf5;text-align: center;cursor: pointer;">
                            <i
                              class="el-icon-delete operation-delete"
                              title="删除"
                              @click="deleteProjectPhaseItem(projectPhaseItemIndex, index)"
                            ></i>
                          </div>
                        </div>
                      </draggable>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
<!--              <el-row :gutter="20">-->
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="阶段奖励">-->
<!--                    <div>-->
<!--                      <el-switch v-model="item.needGradeReward"-->
<!--                                 inactive-text="奖励学分"></el-switch>-->
<!--                      <el-input style="margin-left: 24px;" type="number" :size="componentSize"-->
<!--                                v-model="item.gradeReward" v-if="item.needGradeReward"-->
<!--                                placeholder="请输入奖励学分"-->
<!--                                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"-->
<!--                                oninput="if(value.length > 8) value=value.slice(0, 8)"-->
<!--                                auto-complete="off" maxlength="10" clearable></el-input>-->
<!--                      <span v-if="item.needGradeReward">学分</span>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      <el-switch v-model="item.needCertificateReward"-->
<!--                                 inactive-text="奖励证书"></el-switch>-->
<!--                      <el-button type="primary" style="margin-left: 24px;" :size="componentSize"-->
<!--                                 @click="showCertificateDialog(1)"-->
<!--                                 v-if="item.needCertificateReward">添加证书-->
<!--                      </el-button>-->
<!--                      <div v-if="item.needCertificateReward">-->
<!--                        <el-tag-->
<!--                          v-for="(certificate, certificateIndex) in item.certificateList"-->
<!--                          :key="certificate.id"-->
<!--                          closable-->
<!--                          @close="handlePhaseTabClose(certificateIndex, index)"-->
<!--                          type="info">-->
<!--                          {{certificate.name}}-->
<!--                        </el-tag>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->

<!--              <el-row :gutter="20">-->
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="合格标准">-->
<!--                    <div>-->
<!--                      <el-switch v-model="item.needLearningRate"-->
<!--                                 inactive-text="学习进度"></el-switch>-->
<!--                      <span style="margin-left: 24px;" v-if="item.needLearningRate">达到</span>-->
<!--                      <el-input type="number" :size="componentSize"-->
<!--                                v-model="item.learningRate"-->
<!--                                v-if="item.needLearningRate"-->
<!--                                placeholder="请输入学习进度"-->
<!--                                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"-->
<!--                                oninput="if(value> 100) {value=100} if(value < 0) {value=0}"-->
<!--                                auto-complete="off" maxlength="10" clearable></el-input>-->
<!--                      <span v-if="item.needLearningRate">%</span>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                      <el-switch v-model="item.needExamPassNum"-->
<!--                                 inactive-text="考试通过"></el-switch>-->
<!--                      <el-input style="margin-left: 24px;" type="number" :size="componentSize"-->
<!--                                v-model="item.examPassNum" v-if="item.needExamPassNum"-->
<!--                                placeholder="请输入考试通过场数"-->
<!--                                onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"-->
<!--                                oninput="if(value.length > 8) value=value.slice(0, 8)"-->
<!--                                auto-complete="off" maxlength="10" clearable></el-input>-->
<!--                      <span v-if="item.needExamPassNum">场</span>-->
<!--                    </div>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
            </el-form>
          </el-tab-pane>
          <el-tab-pane :disabled="list.length === 10" label="+" name="+"></el-tab-pane>
        </el-tabs>

<!--        <div class="title">-->
<!--          <h1 class="h1">内容设置</h1>-->
<!--          <el-divider></el-divider>-->
<!--        </div>-->

<!--        <el-card>-->
<!--          <el-form :model="form" :label-width="formLabelWidth">-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="8">-->
<!--                <el-form-item label="模式选择" prop="mode">-->
<!--                  <el-radio-group v-model="form.mode">-->
<!--                    <el-radio-button :label="1">自由模式</el-radio-button>-->
<!--                    <el-radio-button :label="2">闯关模式</el-radio-button>-->
<!--                  </el-radio-group>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row :gutter="20" v-if="form.mode === '闯关模式'">-->
<!--              <el-col :span="8">-->
<!--                <el-form-item label="项目闯关" prop="name">-->
<!--                  <el-switch v-model="form.inOrder" inactive-text="奖励学分"></el-switch>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="8">-->
<!--                <el-form-item label="展示样式" prop="displayMode">-->
<!--                  <el-radio-group v-model="form.displayMode">-->
<!--                    <el-radio-button :label="1">列表样式</el-radio-button>-->
<!--                    <el-radio-button :label="2">地图样式</el-radio-button>-->
<!--                  </el-radio-group>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-form>-->
<!--        </el-card>-->

        <div class="title">
          <h1 class="h1">合格设置</h1>
          <el-divider></el-divider>
        </div>

        <el-card>
          <el-form ref="stepTwo" :model="form" :label-width="formLabelWidth" :rules="stepTwoFormRules">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="项目奖励">
                  <div>
                    <el-switch v-model="form.needGradeReward"  :active-value="1" :inactive-value="-1" inactive-text="奖励学分"></el-switch>
                    <el-input style="margin-left: 24px;" type="number" :size="componentSize"
                              v-model="form.gradeReward" v-if="form.needGradeReward"
                              placeholder="请输入奖励学分"
                              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                              oninput="if(value.length > 8) value=value.slice(0, 8)"
                              auto-complete="off" maxlength="10" clearable></el-input>
                    <span v-if="form.needGradeReward">学分</span>
                  </div>
                  <div>
                    <el-switch v-model="form.needCertificateReward":active-value="1" :inactive-value="-1" inactive-text="奖励证书"></el-switch>
                    <el-button type="primary" style="margin-left: 24px;" :size="componentSize"
                               @click="showCertificateDialog(2)"
                               v-if="form.needCertificateReward">添加证书
                    </el-button>
                    <div v-if="form.needCertificateReward">
                      <el-tag
                        v-for="(certificate, certificateIndex) in form.certificateList"
                        :key="certificate.id"
                        closable
                        @close="handleTabClose(certificateIndex)"
                        type="info">
                        {{certificate.name}}
                      </el-tag>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="合格标准">
                  <div>
                    <el-switch v-model="form.needLearningRate" :active-value="1" :inactive-value="-1" inactive-text="学习进度"></el-switch>
                    <span style="margin-left: 24px;" v-if="form.needLearningRate">达到</span>
                    <el-input type="number" :size="componentSize" v-model="form.learningRate"
                              v-if="form.needLearningRate"
                              placeholder="请输入学习进度"
                              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                              oninput="if(value> 100) {value=100} if(value < 0) {value=0}"
                              auto-complete="off" maxlength="10" clearable></el-input>
                    <span v-if="form.needLearningRate">%</span>
                  </div>
                  <div>
                    <el-switch v-model="form.needExamPassNum" :active-value="1" :inactive-value="-1" inactive-text="考试通过"></el-switch>
                    <el-input style="margin-left: 24px;" type="number" :size="componentSize"
                              v-model="form.examPassNum" v-if="form.needExamPassNum"
                              placeholder="请输入考试通过场数"
                              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                              oninput="if(value.length > 8) value=value.slice(0, 8)"
                              auto-complete="off" maxlength="10" clearable></el-input>
                    <span v-if="form.needExamPassNum">场</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <el-row :gutter="20" style="margin-top: 24px;">
          <el-col :span="4" :offset="20">
            <el-button type="primary" @click="saveStepTwo">下一步</el-button>
          </el-col>
        </el-row>
      </el-card>

      <el-card class="learning-setting" v-if="active === 3">
        <div class="title">
          <h1 class="h1">学习设置</h1>
          <el-divider></el-divider>
        </div>

        <el-form ref="stepThree" :model="form" :label-width="formLabelWidth" :rules="stepThreeFormRules">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="防作弊">
<!--                <div>-->
<!--                  <el-switch v-model="form.antiHang" :active-value="1" :inactive-value="-1" inactive-text="防挂机"></el-switch>-->
<!--                </div>-->
                <div>
                  <el-switch v-model="form.antiDrag" :active-value="1" :inactive-value="-1" inactive-text="防拖拽"></el-switch>
                </div>
                <div>
                  <el-switch v-model="form.timesSpeed" :active-value="1" :inactive-value="-1" inactive-text="倍速播放"></el-switch>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="2" :offset="22">
              <el-button type="primary" @click="saveProject">发布</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <el-dialog title="添加商品" :visible.sync="addFormVisible" width="70%" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <el-card>
          <el-row :span="24">
            <el-col :sm="8" :md="8" :lg="6">
              <el-cascader :show-all-levels="false" ref="tree" placeholder="请选择所属科目" collapse-tags
                           v-model="searchForm.subjectIds" @change="goodsPageListSubjectChange"
                           :options="subjectTree" :props="subjectTreeProps" clearable></el-cascader>
            </el-col>
            <el-col :sm="8" :md="8" :lg="6">
              <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
            </el-col>
            <el-col :sm="5" :md="5" :lg="6" align="right">
              <el-button type="primary" @click="pageList">查询</el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card style="margin-top: 24px;">
          <el-row :span="24">
            <el-col :span="12">
              <el-button type="primary" @click="closeDialog" icon="el-icon-plus">添加到阶段内容中</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table ref="multipleTables" v-loading="loading" height="400" :data="addFormVisibleList"
                        tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="selectionChange"
                        border>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" width="370" show-overflow-tooltip label="商品">
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                      <span>
                        <img style="margin-right: 10px" height="60" width="109" :src="
                          row.row.logo
                            ? row.row.logo
                            : '../../../static/image/noImg.png'
                        "/>
                      </span>
                      </el-col>
                      <el-col :span="16">
                        <span style="color: rgb(77, 148, 255); margin-left: 10px">{{ row.row.name }}</span>
                        <span style="display: block; margin-left: 10px">
                        <span style="color: red">￥{{ row.row.price }}</span>
                        <span style="
                            text-decoration: line-through;
                            color: rgb(162, 170, 188);
                          ">￥{{ row.row.originalPrice }}</span>
                      </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="agentPrice" label="售价">
                  <template slot-scope="row">
                  <span style="display: block">
                    <span style="color: red">￥{{ row.row.agentPrice }}</span>
                    <span style="
                        text-decoration: line-through;
                        color: rgb(162, 170, 188);
                      ">￥{{ row.row.price }}</span>
                  </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="validDay" label="有效期">
                  <template slot-scope="row">{{
                      row.row.validDay ? row.row.validDay + '天' : '不限'
                    }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip width="60" prop="goodsCount" label="内容"></el-table-column> -->
              </el-table>
              <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
                             style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize"
                             :current-page="page.pageNumber" @size-change="sizeChange"
                             @current-change="currentChange"></el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
    </el-dialog>

    <el-dialog title="添加考试" :visible.sync="examSettingVisible" width="70%" left :close-on-click-modal="false">
      <test-paper-setting ref="testPaper" @getExamSettingList="getExamSettingList"></test-paper-setting>
    </el-dialog>

    <el-dialog title="选择证书" :visible.sync="certificateVisible" width="70%" left :close-on-click-modal="false">
      <certificate ref="certificate" @getCertificateList="getCertificateList"></certificate>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import testPaperSetting from "./testPaperSetting";

import {mapGetters} from "vuex";
import certificate from "./certificate";

export default {
  name: "add",
  components: {
    certificate,
    draggable,
    testPaperSetting
  },
  data() {
    return {
      blockAddProject: false,
      certificateListType: 1,
      certificateVisible: false,
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      examSettingVisible: false,
      addFormVisibleList: [],
      loading: false,
      searchForm: {
        type: '录播',
        name: '',
        subjectIds: []
      },
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      activeTab: '阶段1',
      list: [{
        sn: 1,
        label: '阶段1',
        name: '',
        remark: '',
        projectPhaseItemList: [],
        needGradeReward: false,
        gradeReward: 0,
        needCertificateReward: false,
        certificateReward: 0,
        needLearningRate: false,
        learningRate: 0,
        needExamPassNum: false,
        examPassNum: 0,
        certificateList: []
      }],
      active: 1,
      componentSize: '',
      form: {
        name: '',
        cover: '',
        remark: '',
        subjectId: '',
        teacherId: '',
        courseIds: [],
        budget: '',
        mode: 2,
        displayMode: 1,
        projectPhaseList: [],
        certificateReward: 0,
        antiHang: -1,
        antiDrag: -1,
        timesSpeed: 1,
        certificateList: []
      },
      formLabelWidth: "80px",
      stepOneFormRules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "商品名称长度在1到20个字",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传封面",
            trigger: "change",
          }
        ],
        subjectId: [
          {
            required: true,
            message: "请选择科目",
            trigger: "change",
          }
        ],
        teacherId: [
          {
            required: true,
            message: "请选择讲师",
            trigger: "change",
          }
        ]
      },
      phaseFormRules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "商品名称长度在1到20个字",
          },
        ]
      },
      stepTwoFormRules: {

      },
      stepThreeFormRules: {

      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTree: [],
      campusIds: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      campusTree: [],
      teacherList: [],
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  created() {

  },
  methods: {
    ...mapGetters(["loginData"]),
    handlePhaseTabClose(tagIndex, listIndex) {
      this.list[listIndex].certificateList.splice(tagIndex, 1);
      this.$forceUpdate();
    },
    handleTabClose(tagIndex) {
      this.form.certificateList.splice(tagIndex, 1);
      this.$forceUpdate();
    },
    handleRemove(file, fileList) {
    },
    handleChange(file, fileList) {
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess(res, file, fileList, val) {
      this.form.cover = res.data;
    },
    saveProject() {
      if(this.blockAddProject) {
        return false
      }
      this.blockAddProject = true
      this.form.projectPhaseList = this.list
      this.api.project.addProject(this.form).then(result => {
        if (result.success) {
          this.$message.success(result.message)
          this.$router.push({
            path: '/project'
          })
        }else {
          this.$message.error(result.message)
        }
        this.blockAddProject = false
      }).catch(error => {
        this.blockAddProject = false
        console.log(error)
      })
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    closeDialog() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择需要添加的内容')
        return
      }
      this.addFormVisible = false
      let index = parseInt(this.activeTab.replace('阶段', ''))
      for (let i = 0; i < this.list.length; i++) {
        if(index === this.list[i].sn) {
          for (let j = 0; j < this.multipleSelection.length; j++) {
            this.list[i].projectPhaseItemList.push({
              objectId: this.multipleSelection[j].id,
              sn: this.list[i].projectPhaseItemList.length + 1,
              type: 1,
              name: this.multipleSelection[j].name,
              timeLong: ''
            })
          }
        }
      }
      this.multipleSelection = []
    },
    getCertificateList(list) {
      this.certificateVisible = false
      if (this.certificateListType === 1) {
        let index = parseInt(this.activeTab.replace('阶段', ''))
        for (let i = 0; i < this.list.length; i++) {
          if(index === this.list[i].sn) {
            this.list[i].certificateList = list
          }
        }
      } else {
        this.form.certificateList = list
      }
    },
    getExamSettingList(list) {
      this.examSettingVisible = false
      let index = parseInt(this.activeTab.replace('阶段', ''))
      for (let i = 0; i < this.list.length; i++) {
        if(index === this.list[i].sn) {
          for (let j = 0; j < list.length; j++) {
            this.list[i].projectPhaseItemList.push({
              objectId: list[j].id,
              sn: this.list[i].projectPhaseItemList.length + 1,
              type: 2,
              name: list[j].subjectCourse.name + '-' + list[j].sequence,
              timeLong: list[j].examBeginTime + '~' + list[j].examEndTime
            })
          }
        }
      }
    },
    showCertificateDialog(type) {
      this.certificateListType = type
      this.certificateVisible = true
      this.$refs.certificate.pageList();
    },
    showGoodsDialog() {
      this.addFormVisible = true
      this.pageList()
    },
    showExamDialog() {
      this.examSettingVisible = true
      this.$refs.testPaper.pageList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.type = '录播';
      this.api.goodsInfo.pageList(this.searchForm).then(result => {
        this.loading = false;
        this.addFormVisibleList = result.data.records;
        this.page.total = result.data.total;
        this.arrsSelect = [];
      }).catch(error => {
        console.log(error);
      });
    },
    deleteProjectPhaseItem(itemIndex, listIndex) {
      this.list[listIndex].projectPhaseItemList.splice(itemIndex, 1)
      this.list[listIndex].projectPhaseItemList.forEach((e, index) => e.sn = index + 1)
    },
    handleDrag(e, listIndex) {
      this.list[listIndex].projectPhaseItemList.forEach((item, index) => item.sn = index + 1);
      e.preventDefault();
    },
    clickTab(tab) {
      if (tab.label === '+') {
        let sn = this.list.length + 1
        if (sn > 10) {
          this.$message.error('最多10个阶段')
          return
        }

        let obj = {
          sn: sn,
          label: `阶段${sn}`,
          name: '',
          remark: '',
          projectPhaseItemList: [],
          needGradeReward: false,
          gradeReward: 0,
          needCertificateReward: false,
          certificateReward: 0,
          needLearningRate: false,
          learningRate: 0,
          needExamPassNum: false,
          examPassNum: 0,
          certificateList: []
        };

        this.activeTab = `阶段${sn}`;
        this.list.push(obj);
        console.log('this.list', this.list)
        this.list = this.list.sort((a, b) => a.sn - b.sn);
      }
    },
    removeTab(tab) {
      if (1 === this.list.length) {
        this.$message.error('必须保留一个阶段')
        return
      }
      this.$confirm('确认要删除此阶段吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let index = parseInt(tab.replace('阶段', ''))
        this.activeTab = `阶段${index - 1 === 0 ? 1 : index - 1}`
        this.list.splice(index - 1, 1);
        this.list.forEach((e, index) => {
          this.list[index].sn = index + 1
        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {

      });
    },

    saveStepOne() {
      this.$refs.stepOne.validate(valid => {
        if (valid) {
          this.handleStep(2)
        }
      })
    },
    saveStepTwo() {
      this.handleStep(3)
    },
    handleStep(index) {
      this.active = index
    },
    setComponentSize() {
      if (document.body.clientWidth <= 992) {
        this.componentSize = 'mini'
        return
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = 'small'
        return
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = 'medium'
      }
    },
    subjectChange() {
      if (this.form.courseIds) {
        this.form.subjectId = this.form.courseIds[1];
      } else {
        this.form.subjectId = "";
      }
    },
    goodsPageListSubjectChange() {
      if (this.searchForm.subjectIds) {
        this.searchForm.subjectId = this.searchForm.subjectIds[1];
      } else {
        this.searchForm.subjectId = "";
      }
    },
    getSubjectTreeList() {
      this.api.getSubjectTreeList({}).then(result => {
        if (result.success) {
          this.subjectTree = result.data;
        } else {
          this.$message.error(result.message);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getCampusTree() {
      this.api.campus.getCampusTree({
        parentId: 1
      }).then(res => {
        if (res.success) {
          this.campusTree = res.data;
        } else {
          this.$message.error(res.message);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    campusChange() {
      if (this.form.courseIds) {
        this.form.campusId = this.campusIds[1];
      } else {
        this.form.campusId = "";
      }
    },
    getAgentTeacherList() {
      this.api.agentUserInfo.getAgentTeacherList().then((result) => {
        if (result.success) {
          this.teacherList = result.data;
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  mounted() {
    this.setComponentSize()
    this.getSubjectTreeList()
    this.getAgentTeacherList()
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.add-project-content {

  .breadcrumb {
    margin: 12px 0;
  }

  .step {
    margin-left: 100px;

    .pointer {
      cursor: pointer;
    }
  }

  .content {
    margin: 24px 0 0 0;

    .project-info {

      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }

      .avatar-uploader-icon {
        border: 1px dashed #d9d9d9;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }

      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }

    .project-content {
      margin: 24px 0 0 0;

      .title {

        .h1 {
          font-size: 24px;
        }
      }
    }

    .learning-setting {

      .title {

        .h1 {
          font-size: 24px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/add.vue